// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__VwTqr","colCheckbox":"styles_colCheckbox__1af6K"};